module.exports = __webpack_public_path__ + "static/media/fuel.61a4f4f6.svg";